export enum BusinessModelRef {
  simple_self_consumption = 'simple_self_consumption',
  self_consumption_with_injection = 'self_consumption_with_injection',
  net_metering = 'net_metering',
  feed_in_tariff = 'feed_in_tariff'
}

export enum InjectionModelRef {
  self_consumption_with_injection = 'self_consumption_with_injection',
  net_metering = 'net_metering',
  total_injection = 'total_injection'
}

export enum ConfigurationRef {
  configuration_off_grid_self_consumption = 'configuration_off_grid_self_consumption',
  configuration_off_grid_self_consumption_genset = 'configuration_off_grid_self_consumption_genset',
  configuration_off_grid_self_consumption_battery = 'configuration_off_grid_self_consumption_battery',
  configuration_off_grid_self_consumption_battery_genset = 'configuration_off_grid_self_consumption_battery_genset',
  configuration_bad_grid_self_consumption_grid = 'configuration_bad_grid_self_consumption_grid',
  configuration_bad_grid_self_consumption_grid_genset = 'configuration_bad_grid_self_consumption_grid_genset',
  configuration_bad_grid_self_consumption_grid_genset_backup = 'configuration_bad_grid_self_consumption_grid_genset_backup',
  configuration_bad_grid_self_consumption_grid_battery = 'configuration_bad_grid_self_consumption_grid_battery',
  configuration_bad_grid_self_consumption_grid_battery_genset = 'configuration_bad_grid_self_consumption_grid_battery_genset',
  configuration_self_consumption_without_injection_grid_24 = 'configuration_self_consumption_without_injection_grid_24',
  configuration_self_consumption_without_injection_grid_24_battery = 'configuration_self_consumption_without_injection_grid_24_battery',
  configuration_self_consumption_with_injection_grid_24_injection = 'configuration_self_consumption_with_injection_grid_24_injection',
  configuration_net_metering_grid_24_injection = 'configuration_net_metering_grid_24_injection',
  configuration_total_injection_grid_24_injection = 'configuration_total_injection_grid_24_injection',
  configuration_total_injection_grid_24_injection_battery = 'configuration_total_injection_grid_24_injection_battery'
}

export enum CurrencyEnum {
  AFN	= 'AFN',
  ALL	= 'ALL',
  DZD	= 'DZD',
  USD	= 'USD',
  EUR	= 'EUR',
  AOA	= 'AOA',
  XCD	= 'XCD',
  ARS	= 'ARS',
  AMD	= 'AMD',
  AWG	= 'AWG',
  AUD	= 'AUD',
  AZM	= 'AZM',
  BSD	= 'BSD',
  BHD	= 'BHD',
  BDT	= 'BDT',
  BBD	= 'BBD',
  BYR	= 'BYR',
  BZD	= 'BZD',
  XOF	= 'XOF',
  BMD	= 'BMD',
  INR	= 'INR',
  BOB	= 'BOB',
  BAM	= 'BAM',
  BWP	= 'BWP',
  NOK	= 'NOK',
  BRL	= 'BRL',
  BND	= 'BND',
  BGN	= 'BGN',
  BIF	= 'BIF',
  CVE	= 'CVE',
  KHR	= 'KHR',
  XAF	= 'XAF',
  CAD	= 'CAD',
  KYD	= 'KYD',
  CLP	= 'CLP',
  CNY	= 'CNY',
  COP	= 'COP',
  KMF	= 'KMF',
  CDF	= 'CDF',
  NZD	= 'NZD',
  CRC	= 'CRC',
  HRK	= 'HRK',
  CUP	= 'CUP',
  CYP	= 'CYP',
  CZK	= 'CZK',
  DKK	= 'DKK',
  DJF	= 'DJF',
  DOP	= 'DOP',
  EGP	= 'EGP',
  SVC	= 'SVC',
  ERN	= 'ERN',
  EEK	= 'EEK',
  SZL	= 'SZL',
  ETB	= 'ETB',
  FKP	= 'FKP',
  FJD	= 'FJD',
  XPF	= 'XPF',
  GMD	= 'GMD',
  GEL	= 'GEL',
  GHC	= 'GHC',
  GIP	= 'GIP',
  GTQ	= 'GTQ',
  GBP	= 'GBP',
  GNF	= 'GNF',
  GWP	= 'GWP',
  GYD	= 'GYD',
  HTG	= 'HTG',
  HNL	= 'HNL',
  HKD	= 'HKD',
  HUF	= 'HUF',
  ISK	= 'ISK',
  IDR	= 'IDR',
  IRR	= 'IRR',
  IQD	= 'IQD',
  ILS	= 'ILS',
  JMD	= 'JMD',
  JPY	= 'JPY',
  JOD	= 'JOD',
  KZT	= 'KZT',
  KES	= 'KES',
  KPW	= 'KPW',
  KRW	= 'KRW',
  KWD	= 'KWD',
  KGS	= 'KGS',
  LAK	= 'LAK',
  LVL	= 'LVL',
  LBP	= 'LBP',
  ZAR	= 'ZAR',
  LRD	= 'LRD',
  LYD	= 'LYD',
  CHF	= 'CHF',
  LTL	= 'LTL',
  MOP	= 'MOP',
  MGA	= 'MGA',
  MWK	= 'MWK',
  MYR	= 'MYR',
  MVR	= 'MVR',
  MTL	= 'MTL',
  MRO	= 'MRO',
  MUR	= 'MUR',
  MXN	= 'MXN',
  MDL	= 'MDL',
  MNT	= 'MNT',
  MAD	= 'MAD',
  MZM	= 'MZM',
  MMK	= 'MMK',
  NPR	= 'NPR',
  NIO	= 'NIO',
  NGN	= 'NGN',
  MKD	= 'MKD',
  OMR	= 'OMR',
  PKR	= 'PKR',
  PAB	= 'PAB',
  PGK	= 'PGK',
  PYG	= 'PYG',
  PEN	= 'PEN',
  PHP	= 'PHP',
  PLN	= 'PLN',
  QAR	= 'QAR',
  ROL	= 'ROL',
  RUR	= 'RUR',
  RWF	= 'RWF',
  WST	= 'WST',
  STD	= 'STD',
  SAR	= 'SAR',
  RSD	= 'RSD',
  SCR	= 'SCR',
  SLL	= 'SLL',
  SGD	= 'SGD',
  ANG	= 'ANG',
  SKK	= 'SKK',
  SIT	= 'SIT',
  SBD	= 'SBD',
  SOS	= 'SOS',
  SSP	= 'SSP',
  LKR	= 'LKR',
  SDD	= 'SDD',
  SRD	= 'SRD',
  SEK	= 'SEK',
  SYP	= 'SYP',
  TWD	= 'TWD',
  TJS	= 'TJS',
  TZS	= 'TZS',
  THB	= 'THB',
  TOP	= 'TOP',
  TTD	= 'TTD',
  TND	= 'TND',
  TRL	= 'TRL',
  TMM	= 'TMM',
  UGX	= 'UGX',
  UAH	= 'UAH',
  AED	= 'AED',
  UYU	= 'UYU',
  UZS	= 'UZS',
  VUV	= 'VUV',
  VEB	= 'VEB',
  VND	= 'VND',
  YER	= 'YER',
  ZMK	= 'ZMK',
  ZWD	= 'ZWD'
}

export enum RegionEnum {
  Métropole = 'Métropole',
  Réunion = 'Réunion',
  Guadeloupe = 'Guadeloupe',
  Guyane = 'Guyane',
  'Martinique Simple Insularité' = 'Martinique Simple Insularité',
  'Martinique Double Insularité' = 'Martinique Double Insularité',
  'Nouvelle Calédonie' = 'Nouvelle Calédonie'
}

export enum RenFrTypeEnum {
  solaire = 'Solaire',
  eolien = 'Eolien'
}

export enum MetropoleRegionEnum {
  'Auvergne-Rhône-Alpes' = 'Auvergne-Rhône-Alpes',
  'Bourgogne-Franche-Comté' = 'Bourgogne-Franche-Comté',
  'Bretagne' = 'Bretagne',
  'Centre-Val de Loire' = 'Centre-Val de Loire',
  'Grand Est' = 'Grand Est',
  'Hauts-de-France' = 'Hauts-de-France',
  'Île-de-France' = 'Île-de-France',
  'Normandie' = 'Normandie',
  'Nouvelle-Aquitaine' = 'Nouvelle-Aquitaine',
  'Occitanie' = 'Occitanie',
  'Provence-Alpes-Côte d\'Azur' = 'Provence-Alpes-Côte d\'Azur',
  'Pays de la Loire' = 'Pays de la Loire',
};

export enum ReferenceScenarioEnum {
  'Scénario de référenceSolaire CRE' = 'Scénario de référenceSolaire CRE',
  'Scénario de référenceSolaire CPPA FPI' = 'Scénario de référenceSolaire CPPA FPI',
  'Scénario de référenceSolaire DOM/TOM' = 'Scénario de référenceSolaire DOM/TOM',
  'Scénario de référenceSolaire Nouvelle Calédonie' = 'Scénario de référenceSolaire Nouvelle Calédonie',
  'Scénario de référenceEolien CRE' = 'Scénario de référenceEolien CRE',
  'Scénario de référenceEolien CPPA FPI' = 'Scénario de référenceEolien CPPA FPI',
  'Scénario de référenceEolien DOM/TOM' = 'Scénario de référenceEolien DOM/TOM'
}

export enum CaseTypeRefScenario {
  'Sol Fixe' = 'Sol Fixe',
  'Trackers' = 'Trackers',
  'Ombrières' = 'Ombrières',
  'Toiture' = 'Toiture',
  'Eolien' = 'Eolien'
}

export enum CaseTypeRefScenarioPV {
  'Sol Fixe' = 'Sol Fixe',
  'Trackers' = 'Trackers',
  'Ombrières' = 'Ombrières',
  'Toiture' = 'Toiture',
}

export enum CaseTypeRefScenarioWind {
  'Eolien' = 'Eolien'
}
